import { ReactComponent as NodeJS } from "../../../../.remote/gatsby-imgly-source/v1.36.x/apps/cesdk_guides/assets/images/imgly/nodejs.svg";
import { ReactComponent as NextJs } from "../../../../.remote/gatsby-imgly-source/v1.36.x/apps/cesdk_guides/assets/images/imgly/nextjs.svg";
import { ReactComponent as Electron } from "../../../../.remote/gatsby-imgly-source/v1.36.x/apps/cesdk_guides/assets/images/imgly/electron.svg";
import { ReactComponent as Svelte } from "../../../../.remote/gatsby-imgly-source/v1.36.x/apps/cesdk_guides/assets/images/imgly/svelte.svg";
import { ReactComponent as Vue } from "../../../../.remote/gatsby-imgly-source/v1.36.x/apps/cesdk_guides/assets/images/imgly/vue.svg";
import { ReactComponent as Angular } from "../../../../.remote/gatsby-imgly-source/v1.36.x/apps/cesdk_guides/assets/images/imgly/angular.svg";
import { ReactComponent as ReactIcon } from "../../../../.remote/gatsby-imgly-source/v1.36.x/apps/cesdk_guides/assets/images/imgly/react.svg";
import { ReactComponent as Javascript } from "../../../../.remote/gatsby-imgly-source/v1.36.x/apps/cesdk_guides/assets/images/imgly/javascript.svg";
import { ReactComponent as Server } from "../../../../.remote/gatsby-imgly-source/v1.36.x/apps/cesdk_guides/assets/images/imgly/server.svg";
import * as React from 'react';
export default {
  NodeJS,
  NextJs,
  Electron,
  Svelte,
  Vue,
  Angular,
  ReactIcon,
  Javascript,
  Server,
  React
};